import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import "./ForgotPassword.css"; // Custom CSS file

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setAlertMessage("");

    if (!email.trim()) {
      setAlertMessage("Enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      const normalizedEmail = email.trim().toLowerCase();
      sessionStorage.removeItem("reset_token");
      sessionStorage.removeItem("reset_email");

      const response = await axiosInstance.post("/api/forget_password", {
        email: normalizedEmail,
      });
      const responseData = response?.data || {};
      const isSuccess = responseData?.success === true;
      const message =
        responseData?.message ||
        "If the email exists, an OTP has been sent.";

      setAlertMessage(message);
      if (isSuccess) {
        sessionStorage.setItem("otp_email", normalizedEmail);
        setTimeout(() => {
          navigate("/otp-verification", {
            state: { email: normalizedEmail },
            replace: true,
          });
        }, 1200);
      }
    } catch (error) {
      console.error("Error during password reset:", error);
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An error occurred. Please try again later.";
      setAlertMessage(backendMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-card">
        <h2 className="forgot-title">Forgot Password</h2>

        {alertMessage && <div className="forgot-alert">{alertMessage}</div>}

        <form onSubmit={handleForgotPassword} className="forgot-form">
          <label htmlFor="email" className="forgot-label">
            Email Address
          </label>
          <input
            type="email"
            id="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="forgot-input"
          />
          <button type="submit" disabled={loading} className="forgot-button">
            {loading ? "Sending..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
